<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <circle class="cls-2" cx="25.5" cy="28.24" r="5.34"/>
  <circle class="cls-2" cx="25.5" cy="45" r="5.34"/>
  <circle class="cls-2" cx="25.5" cy="61.76" r="5.34"/>
  <rect class="cls-3" x="34.03" y="23.69" width="33.79" height="9.09" rx="1.49" ry="1.49"/>
  <rect class="cls-3" x="34.03" y="40.45" width="33.79" height="9.09" rx="1.49" ry="1.49"/>
  <rect class="cls-3" x="34.03" y="57.22" width="33.79" height="9.09" rx="1.49" ry="1.49"/>
  <path class="cls-1" d="m66.32,77.83H23.68c-6.34,0-11.5-5.16-11.5-11.5V23.68c0-6.34,5.16-11.5,11.5-11.5h42.65c6.34,0,11.5,5.16,11.5,11.5v42.65c0,6.34-5.16,11.5-11.5,11.5ZM23.68,15.46c-4.53,0-8.22,3.69-8.22,8.22v42.65c0,4.53,3.69,8.22,8.22,8.22h42.65c4.53,0,8.22-3.69,8.22-8.22V23.68c0-4.53-3.69-8.22-8.22-8.22H23.68Z"/>
</svg>
</template>

<script>
export default {
    name: "SubCategoryRankIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0c5f74;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #cfeae0;
  }
</style>